import ShareIcon from "@mui/icons-material/Share";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import { Translations } from "ui/Scripts/source/models/translations";

interface IListStateIconShareProps {
    noMargin?: boolean;
    tooltip?: string;
    rotation?: number;
}

export const ListStateIconShare = (props: IListStateIconShareProps) => {
    return (
        <ListStateIcon
            tooltip={props.tooltip ?? Translations.Shared}
            icon={ShareIcon}
            noMargin={props.noMargin}
            rotation={props.rotation}
        />
    );
};
